import { format } from 'date-fns';
import { buyPathMap } from 'clientState/providers/SearchRequestProvider/parsers';
import { SemItinerarySelectionRequest, TripType } from 'generated/graphql';

const SEM_BUY_PATH = 98;
export const buildSemSelectionQuery = (
  semItinerary,
  params,
  locations
): SemItinerarySelectionRequest => {
  const {
    type = 'R',
    from,
    to,
    buyPath,
    adults = '1',
    children = '0',
    infants = '0',
  } = params;
  const flightCodes = semItinerary.legs.map((leg) => {
    return leg.segments
      .map((segment) => segment.sections)
      .flat()
      .map((section) => section.flightCode);
  });
  const legs = semItinerary.legs;
  const departureDate = format(
    new Date(legs[0].segments[0].sections[0].departureDate.split('T')[0]),
    'yyyy-MM-dd'
  );
  const returnDate = format(
    new Date(
      legs[legs.length - 1].segments[0].sections[0].departureDate.split('T')[0]
    ),
    'yyyy-MM-dd'
  );
  const selectDealSegmentFlightNumbers = [
    { flightNumbers: flightCodes[0] },
    ...(type === 'R'
      ? [{ flightNumbers: flightCodes[flightCodes.length - 1] }]
      : []),
  ];

  const departureLocation = {
    iata: locations[from].iataCode,
    geoNodeId: locations[from].geoNodeId,
  };
  const returnLocation = {
    iata: locations[to].iataCode,
    geoNodeId: locations[to].geoNodeId,
  };

  const departureTrip = {
    date: departureDate,
    departure: departureLocation,
    destination: returnLocation,
  };
  const returnTrip = {
    date: returnDate,
    departure: returnLocation,
    destination: departureLocation,
  };
  const segments = type === 'R' ? [departureTrip, returnTrip] : [departureTrip];

  return {
    buyPath: buyPathMap[buyPath] || SEM_BUY_PATH,
    tripType: (type === 'R' ? 'ROUND_TRIP' : 'ONE_WAY') as TripType,
    selectDealSegmentFlightNumbers,
    itinerarySearchRequest: {
      numAdults: parseInt(adults, 10),
      numChildren: parseInt(children, 10),
      numInfants: parseInt(infants, 10),
      resident: false,
      mainAirportsOnly: false,
      segments,
    },
  };
};

export const buildRecoverRequest = (semItinerary, params, locations) => {
  const {
    type = 'R',
    from,
    to,
    buyPath,
    adults = 1,
    children = 0,
    infants = 0,
    class: cabinClass = 'TOURIST',
  } = params;
  const legs = semItinerary.legs;
  const departureDate = format(
    new Date(legs[0].segments[0].sections[0].departureDate.split('T')[0]),
    'yyyy-MM-dd'
  );
  const returnDate = format(
    new Date(
      legs[legs.length - 1].segments[0].sections[0].departureDate.split('T')[0]
    ),
    'yyyy-MM-dd'
  );
  const locationFrom = {
    ...locations[from],
    iata: locations[from].iataCode,
  };
  const locationTo = {
    ...locations[to],
    iata: locations[to].iataCode,
  };
  const departureTrip = {
    dateStr: departureDate,
    departure: locationFrom,
    destination: locationTo,
  };
  const returnTrip = {
    dateStr: returnDate,
    departure: locationTo,
    destination: locationFrom,
  };
  const searchSegments =
    type === 'R' ? [departureTrip, returnTrip] : [departureTrip];
  return {
    buyPath: buyPath || SEM_BUY_PATH,
    type: type === 'R' ? 'roundTrip' : 'oneWayTrip',
    cabinClass,
    directFlightsOnly: false,
    internalSearch: true,
    creationDate: new Date().getTime(),
    numAdults: adults,
    numChildren: children,
    numInfants: infants,
    priceTrend: [],
    resident: false,
    searchSegments,
    departureDate,
    returnDate,
  };
};
